import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/imgs/button/button6.png';
const _withScopeId = n => (_pushScopeId("data-v-4c2c55f7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ml10 p20"
};
const _hoisted_2 = {
  class: "base_info"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "个人信息", -1));
const _hoisted_4 = {
  class: "mt15 base_info_item",
  style: {
    "width": "15.625vw"
  }
};
const _hoisted_5 = {
  class: "mt15 base_info_item",
  style: {
    "width": "15.625vw"
  }
};
const _hoisted_6 = {
  class: "flex_FSBC mt15",
  style: {
    "width": "16.625vw"
  }
};
const _hoisted_7 = {
  class: "base_info_item flex_size_1 mr15"
};
const _hoisted_8 = {
  class: "mt25 invice_title"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title text_white"
}, "抬头管理", -1));
const _hoisted_10 = {
  key: 1,
  class: "flex mt15 text_white"
};
const _hoisted_11 = {
  class: "flex_size_1"
};
const _hoisted_12 = {
  class: "pl50"
};
const _hoisted_13 = {
  class: "flex_size_1 flex_FSC"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "dot mr5 mt5",
  src: _imports_0
}, null, -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "默认", -1));
const _hoisted_16 = {
  key: 2,
  class: "mt35 _form"
};
const _hoisted_17 = {
  class: "_form_main"
};
const _hoisted_18 = {
  class: "textC text_blue _form_main_title"
};
const _hoisted_19 = {
  class: "flex_FSBS"
};
const _hoisted_20 = {
  class: "flex_size_1 mr70"
};
const _hoisted_21 = {
  class: "flex"
};
const _hoisted_22 = {
  class: "flex_size_1"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mb20",
  style: {
    "color": "#3b7ce1"
  }
}, "以下信息非必填", -1));
const _hoisted_24 = {
  key: 0,
  class: "flex_FSBS"
};
const _hoisted_25 = {
  class: "flex_size_1 mr70"
};
const _hoisted_26 = {
  class: "flex_size_1"
};
const _hoisted_27 = {
  class: "flex_FCAC mt60"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_form = _resolveComponent("el-form");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("p", _hoisted_4, " 账户：" + _toDisplayString($setup.phoneDesc($setup.mainStore.userInfo?.nickName)), 1), _createElementVNode("p", _hoisted_5, " 手机号：" + _toDisplayString($setup.phoneDesc($setup.mainStore.userInfo?.phoneNumber)), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("p", _hoisted_7, " 身份验证：" + _toDisplayString($setup.AuthTypeMap[$setup.data.identityAuth.toString()].label), 1), _createVNode(_component_el_button, {
    type: "primary",
    onClick: $setup.goVerify
  }, {
    default: _withCtx(() => [_createTextVNode("去认证")]),
    _: 1
  }, 8, ["onClick"])])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, !$setup.data.invoiceTitleList.length ? (_openBlock(), _createElementBlock("p", {
    key: 0,
    class: "invice_title_add mt15 pointer",
    onClick: _cache[0] || (_cache[0] = () => $setup.openDialog())
  }, " 新增抬头 ")) : _createCommentVNode("", true), $setup.data.invoiceTitleList.length ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("span", null, " 公司名称：" + _toDisplayString($setup.data.invoiceTitleList[0].name), 1), _createElementVNode("span", _hoisted_12, "类型：" + _toDisplayString($setup.invoiceTypeList[$setup.data.invoiceTitleList[0].invoiceType]), 1)]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _hoisted_15, _createElementVNode("p", {
    class: "pointer ml70 invice_title_edit",
    onClick: _cache[1] || (_cache[1] = () => $setup.openDialog($setup.data.invoiceTitleList[0]))
  }, " 管理 ")])])) : _createCommentVNode("", true), $setup.data.dialog.visible ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("p", _hoisted_18, _toDisplayString($setup.data.dialog.invoiceId ? "修改抬头" : "新增抬头"), 1), _createVNode(_component_el_form, {
    class: "mt20",
    ref: "formRef",
    model: $setup.formData,
    rules: $setup.rules,
    "status-icon": ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createVNode(_component_el_form_item, {
      label: "抬头类型",
      "label-width": "4vw"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        disabled: "",
        value: "企业单位"
      })]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "名称",
      prop: "name",
      "label-width": "4vw"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.formData.name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.formData.name = $event),
        placeholder: "请输入名称"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "手机",
      prop: "phone",
      "label-width": "4vw"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.formData.phone,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.formData.phone = $event),
        maxlength: "11",
        placeholder: "请输入手机"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createElementVNode("div", _hoisted_21, [_createVNode(_component_el_form_item, {
      label: "应税地",
      prop: "taxableProvince",
      "label-width": "4vw"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        style: {
          "width": "6vvw"
        },
        modelValue: $setup.formData.taxableProvince,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.formData.taxableProvince = $event),
        filterable: "",
        placeholder: "请选择应税地(省)",
        onChange: _cache[5] || (_cache[5] = value => $setup.selectOtherAdDivisionList($setup.data.provinces.filter(item => item.adDivisionName == $setup.formData.taxableProvince)[0].adDivisionCode, 'cities'))
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.provinces, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.adDivisionName,
            label: item.adDivisionName,
            value: item.adDivisionName
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "ml5",
      label: "",
      prop: "taxableCity"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        style: {
          "width": "6vvw"
        },
        modelValue: $setup.formData.taxableCity,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $setup.formData.taxableCity = $event),
        filterable: "",
        placeholder: "请选择应税地(市)",
        onChange: _cache[7] || (_cache[7] = value => $setup.selectOtherAdDivisionList($setup.data.cities.filter(item => item.adDivisionName == $setup.formData.taxableCity)[0].adDivisionCode, 'districts'))
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.cities, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.adDivisionName,
            label: item.adDivisionName,
            value: item.adDivisionName
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "ml5",
      label: "",
      prop: "taxableDistrict"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        style: {
          "width": "6vvw"
        },
        modelValue: $setup.formData.taxableDistrict,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $setup.formData.taxableDistrict = $event),
        filterable: "",
        placeholder: "请选择应税地(区)",
        onChange: _cache[9] || (_cache[9] = value => $setup.selectOtherAdDivisionList($setup.data.districts.filter(item => item.adDivisionName == $setup.formData.taxableDistrict)[0].adDivisionCode, 'counties'))
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.districts, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.adDivisionName,
            label: item.adDivisionName,
            value: item.adDivisionName
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "ml5",
      label: "",
      prop: "taxableCounty"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        style: {
          "width": "6vvw"
        },
        modelValue: $setup.formData.taxableCounty,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $setup.formData.taxableCounty = $event),
        filterable: "",
        placeholder: "请选择应税地(县)"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.counties, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.adDivisionName,
            label: item.adDivisionName,
            value: item.adDivisionName
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })])]), _createElementVNode("div", _hoisted_22, [$setup.formData.invoiceType == 1 ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 0,
      label: "纳税人识别号",
      prop: "taxNo",
      "label-width": "6vw"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.formData.taxNo,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $setup.formData.taxNo = $event),
        placeholder: "请输入纳税人识别号"
      }, null, 8, ["modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
      label: "收件邮箱",
      prop: "email",
      "label-width": "6vw"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.formData.email,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $setup.formData.email = $event),
        placeholder: "请输入收件邮箱"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "设置默认",
      "label-width": "6vw"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_switch, {
        modelValue: $setup.formData.isDefault,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $setup.formData.isDefault = $event),
        disabled: ""
      }, null, 8, ["modelValue"])]),
      _: 1
    })])]), _hoisted_23, $setup.formData.invoiceType != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createVNode(_component_el_form_item, {
      label: "开户银行",
      "label-width": "4vw"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.formData.openBank,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $setup.formData.openBank = $event),
        placeholder: "请输入开户银行"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "电话号码",
      "label-width": "4vw"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.formData.workPhone,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $setup.formData.workPhone = $event),
        maxlength: "11",
        placeholder: "请输入电话号码"
      }, null, 8, ["modelValue"])]),
      _: 1
    })]), _createElementVNode("div", _hoisted_26, [_createVNode(_component_el_form_item, {
      label: "银行账户",
      "label-width": "6vw"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.formData.bankNo,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $setup.formData.bankNo = $event),
        placeholder: "请输入银行账户"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "单位地址",
      "label-width": "6vw"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.formData.workAddress,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $setup.formData.workAddress = $event),
        placeholder: "请输入单位地址"
      }, null, 8, ["modelValue"])]),
      _: 1
    })])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["model", "rules"])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("p", {
    class: "_form_cancel pointer",
    onClick: _cache[18] || (_cache[18] = (...args) => $setup.closeDialog && $setup.closeDialog(...args))
  }, "取消"), _createElementVNode("p", {
    class: "ml20 _form_save pointer",
    onClick: _cache[19] || (_cache[19] = $event => $setup.submitForm($setup.formRef))
  }, _toDisplayString($setup.data.dialog.invoiceId ? "修改" : "保存"), 1)])])) : _createCommentVNode("", true)])]);
}